import axios from "axios";

export async function getResults({ commit }, payload) {
  try {
    const {data} = await axios.get(`strain/get-results-v2/${payload}`);
    return data;
  } catch (e) {
    return e;
  }
}
